const allapplications = [
  {
    id: 1,
    name: 'Driver Barrywood North 1',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. \n Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. \n It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 2,
    name: 'Provider SE Columbus 2',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 3,
    name: 'Provider SE Columbus 3',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
    ],
  },
  {
    id: 4,
    name: 'Provider SE Columbus 4',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
    ],
  },
  {
    id: 2,
    name: 'Provider SE Columbus 2',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 5,
    posted_date: 'October 17, 2021',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'expired',
  },

  {
    id: 7,
    name: 'Provider SE Columbus 7',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'submitted',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Own computer',
    ],
  },

  {
    id: 8,
    name: 'Provider SE Columbus 8',
    posted_date: 'October 17, 2021',
    description:
      'It is my pleasure to extend to you an offer to join the network of Laundry Care providers! Please review the information below and accept or decline the offer. We would like for your start date to be March 25, 2022.',
    actions: ['Acttion 1', 'Action 2', 'Action 3'],
    postion_details: ['Detail 1', 'Detail 2', 'Detail 3'],
    responsibilities_include: [
      'Responsibility 1',
      'Responsibility 2',
      'Responsibility 3',
    ],
    status: 'offer pending',
    requirements: ['Requirement 1', 'Requirement 2', 'Requirement 3'],
  },
  {
    id: 9,
    name: 'Provider SE Columbus 9',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'in review',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },

  {
    id: 10,
    name: 'Provider SE Columbus 10',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'offer accepted',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 11,
    name: 'Provider SE Columbus 11',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'closed',
    requirements: [
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },

  {
    id: 12,
    name: 'Provider SE Columbus 12',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'declined',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Own computer',
      'Clean background',
    ],
  },
];

const applications = {
  started: [
    {
      name: 'Driver Barrywood North 1',
      date: 'October 17, 2021',
      status: 'started',
      id: 1,
    },
    {
      name: 'Provider SE Columbus 2',
      date: 'October 17, 2021',
      status: 'started',
      id: 2,
    },
    {
      name: 'Provider SE Columbus 3',
      date: 'October 17, 2021',
      status: 'started',
      id: 3,
    },
    {
      name: 'Provider SE Columbus 4',
      date: 'October 17, 2021',
      status: 'started',
      id: 4,
    },
    {
      name: 'Provider SE Columbus 5',
      date: 'October 17, 2021',
      status: 'Expired',
      id: 5,
    },
  ],
  completed: [
    {
      name: 'Provider SE Columbus 7',
      date: 'October 17, 2021',
      status: 'Submitted',
      id: 7,
    },
    {
      name: 'Provider SE Columbus 8',
      date: 'October 17, 2021',
      status: 'Offer pending',
      id: 8,
    },
    {
      name: 'Provider SE Columbus 9',
      date: 'October 17, 2021',
      status: 'In review',
      id: 9,
    },

    {
      name: 'Provider SE Columbus 11',
      date: 'October 17, 2021',
      status: 'Offer accepted',
      id: 10,
    },
    {
      name: 'Provider SE Columbus 11',
      date: 'October 17, 2021',
      status: 'Closed',
      id: 11,
    },
    {
      name: 'Provider SE Columbus 12',
      date: 'October 17, 2021',
      status: 'Declined',
      id: 12,
    },
  ],
};

const alljobs = [
  {
    id: 1,
    name: 'Driver Barrywood North 1',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. \n Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. \n It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'new',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 2,
    name: 'Provider SE Columbus 2',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'started',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 3,
    name: 'Provider SE Columbus 3',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'submitted',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
    ],
  },
  {
    id: 4,
    name: 'Provider SE Columbus 4',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'offer pending',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
    ],
  },
  {
    id: 5,
    name: 'Provider SE Columbus 5',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'in review',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 6,
    name: 'Provider SE Columbus 6',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'offer accepted',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Own computer',
    ],
  },
  {
    id: 7,
    name: 'Provider SE Columbus 7',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'expired',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 8,
    name: 'Provider SE Columbus 8',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'closed',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
  {
    id: 9,
    name: 'Provider SE Columbus 9',
    posted_date: 'October 17, 2021',
    description:
      'A job description template is a reusable model that can be tailored to detail the specific requirements, responsibilities, job duties, and skills required to perform a role. It typically includes a list of common daily tasks, equipment or tools used, who the role reports to, and the overall goals of the role. Apart from being able to define what employers are looking for within the typical role an applicant is applying for, it also helps them ensure that they feature the best keywords into the skills and qualities sections of any applications searched and prioritized electronically. It’s rare that a pair of human eyes ever sees the complete application pool when a post attracts a vast number of applicants. We live in a data driven world, so an applicant must make sure their data matches what an employer — or their AI software — is looking for.',
    region: 'Columbus',
    start_date: 'October 17, 2021',
    end_date: 'October 17, 2021',
    status: 'offer declined',
    requirements: [
      '303 Pinewood Cir, Plymouth, MI',
      'Laundry',
      '+1 year previous experience',
      'Downtown',
      '18+ years old',
      'Own computer',
      'Clean background',
    ],
  },
];

const jobs = {
  data: [
    {
      name: 'Driver Barrywood North 1',
      date: 'October 17, 2021',
      status: 'new',
      id: 1,
    },
    {
      name: 'Provider SE Columbus 2',
      date: 'October 17, 2021',
      status: 'started',
      id: 2,
    },
    {
      name: 'Provider SE Columbus 3',
      date: 'October 17, 2021',
      status: 'submitted',
      id: 3,
    },
    {
      name: 'Provider SE Columbus 4',
      date: 'October 17, 2021',
      status: 'offer pending',
      id: 4,
    },
    {
      name: 'Provider SE Columbus 5',
      date: 'October 17, 2021',
      status: 'in review',
      id: 5,
    },
    {
      name: 'Provider SE Columbus 6',
      date: 'October 17, 2021',
      status: 'offer accepted',
      id: 6,
    },
    {
      name: 'Provider SE Columbus 7',
      date: 'October 17, 2021',
      status: 'expired',
      id: 7,
    },
    {
      name: 'Provider SE Columbus 8',
      date: 'October 17, 2021',
      status: 'closed',
      id: 8,
    },
    {
      name: 'Provider SE Columbus 9',
      date: 'October 17, 2021',
      status: 'offer declined',
      id: 9,
    },
  ],
};

const profile = {
  Name: 'Jennie Smith',
  Email: 'testprovider@gmail.com',
  Phone_Number: '555-555-5555',
  Address: '299-201 Nevada St. San Francisco, CA 12345',
  Date_of_Birth: '10-02-1987',
  Referral_code: '123-458 (referred by John Smith)',
  'Resume/CV': 'John Smith Resume.pdf',
};

const states = [
  {
    id: 1,
    state: 'MI',
    area: 'Ann Arbor',
    locations: ['Canton', 'Ypsilanti', 'Downtown', 'South East', 'South West'],
  },
  {
    id: 2,
    state: 'TX',
    area: 'Austin',
    locations: [
      'North West',
      'North East',
      'Central Austin',
      'South East',
      'South West',
    ],
  },
  {
    id: 3,
    state: 'MD',
    area: 'Baltimore',
    locations: ['Downtown', 'Dundalk', 'Downtown', 'Ellicott City', 'Dundalk'],
  },
  {
    id: 4,
    state: 'FL',
    area: 'Orlando',
    locations: [
      'Downtown',
      'Dundalk',
      'Ellicott City',
      'South East',
      'South West',
    ],
  },
];

export { allapplications, applications, alljobs, jobs, profile, states };
